<div class="level-2">
  <div class="col-12">
    <h1 class="h-main h-main-medium corporate">{{ 'app_advance_simulator_form_title' | translate }}</h1>
  </div>

  <div class="row primary-info-box">
    <p class="info-text">{{ 'app_advance_simulator_form_sub_title' | translate }}</p>

    <h2 class="col-12 no-pd h-main h-main-medium">{{ 'app_advance_simulator_form_section_mortgage' | translate }}</h2>
    <div class="col-12 no-pd pre-simulator">
      <app-pre-simulator-form [isAdvanceSimulator]="true" (sendForm)="setMortgageForm($event)">
      </app-pre-simulator-form>
    </div>

    <div class="col-12 no-pd">
      <div class="row bg-block">
        <h2 class="col-12 h-main h-main-medium">{{ 'app_advance_simulator_form_generic_data' | translate }}</h2>

        <div class="col">
          <form [formGroup]="advanceSimulatorForm">
            <input type="hidden" formControlName="titularNumber" value="1" />
            <div class="input-box">
              <label
                for="expensesOtherLoad"
                [class.has-error]="
                  advanceSimulatorForm.controls['expensesOtherLoad'].touched &&
                  !advanceSimulatorForm.controls['expensesOtherLoad'].valid
                "
                >{{ 'app_advance_simulator_form_expensesOtherLoad' | translate }}
                <a
                  id="tooltip-expensesOtherLoad"
                  class="icon-a"
                  href="javascript:void(0)"
                  tooltipEvent="focus"
                  [pTooltip]="'app_advance_simulator_form_tooltip_expensesOtherLoad' | translate"
                  (click)="openToast('tooltip-expensesOtherLoad')"
                >
                  <img class="ico-info" src="assets/img/info.svg" />
                </a>
              </label>
              <amount-input
                [config]="{
                  id: 'expensesOtherLoad',
                  inputFormat: '*-2',
                  placeholder: '',
                  maxlength: 6,
                  xDeleteButton: false,
                  styleClass: 'input-number',
                  symbol: '€',
                }"
                formControlName="expensesOtherLoad"
                placeholder="Gastos en otros préstamos"
              >
              </amount-input>
              @if (
                advanceSimulatorForm.controls['expensesOtherLoad'].touched &&
                !advanceSimulatorForm.controls['expensesOtherLoad'].valid
              ) {
                <p class="has-error">
                  {{ 'hipotecas_error_required' | translate }}
                </p>
              }
            </div>
          </form>
        </div>
        <div class="col">
          <form [formGroup]="advanceSimulatorForm">
            <div class="input-box">
              <label
                for="membersFamily"
                [class.has-error]="
                  advanceSimulatorForm.controls['membersFamily'].touched &&
                  !advanceSimulatorForm.controls['membersFamily'].valid
                "
              >
                {{ 'app_advance_simulator_form_members_family' | translate }}</label
              >
              <input
                appOnlyNumbers
                class="form-control"
                id="membersFamily"
                formControlName="membersFamily"
                type="text"
                placeholder=""
                [maxLength]="HTML_VALIDATORS?.maxLength?.membersFamily"
              />
              <div class="error-content">
                @if (
                  advanceSimulatorForm.controls['membersFamily'].touched &&
                  advanceSimulatorForm.controls['membersFamily'].hasError('required')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </form>
        </div>
        <div class="col-12">
          <app-housing-data-form #formHousingData (emitForm)="setFormHousingData($event)"> </app-housing-data-form>
        </div>
      </div>
    </div>
    <div class="col-12 no-pd">
      <form
        *ngFor="let titular of advanceSimulatorForm?.controls['holders']?.controls; let indice = index"
        [formGroup]="titular"
        [class.second-holder]="indice != 0"
        [id]="'form-holder-' + indice"
      >
        <div class="row">
          <div class="col-6">
            @if (indice == 0) {
              <h2 class="h-main h-main-medium col-12">
                {{ 'app_advance_simulator_form_first_holder' | translate }}
              </h2>
            }

            @if (indice != 0) {
              <h2 class="h-main h-main-medium col-12">
                {{ 'app_advance_simulator_form_second_holder' | translate }}
              </h2>
            }
            <h3 class="h-sub-section col-12">{{ 'app_advance_simulator_form_personal_data' | translate }}</h3>
          </div>

          @if (indice == 0 && titulares.length == 1) {
            <div class="col-6 add-holder-content">
              <p class="info-text text-align-right">{{ 'advance_form_info_btn_add_holder' | translate }}</p>
              <button
                id="advance-simulator-form-btn-add-holder"
                class="btn btn-01 add-holder"
                (click)="addOtherTitular()"
              >
                <span class="ic ic-plus"></span>{{ 'app_advance_simulator_form_add_holder' | translate }}
              </button>
            </div>
          }

          @if (indice != 0) {
            <div class="col-6">
              <p class="info-text text-align-right"></p>
              <button
                id="advance-simulator-form-btn-delete-holder"
                (click)="confirmDeleteUser()"
                class="btn btn-05 delete-holder"
              >
                <span class="ic ic-minus"></span>
                {{ 'app_advance_simulator_form_delete_holder' | translate }}
              </button>
            </div>
          }

          <div class="col-12">
            <div
              class="alert alert-info document-info"
              [innerHTML]="'advance_form_info_document_type' | translate"
            ></div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'name' + indice"
                [class.has-error]="titular?.controls['name']?.touched && !titular?.controls['name'].valid"
                >{{ 'app_advance_simulator_form_name' | translate }}</label
              >
              <input
                appOnlyLetters
                class="form-control"
                [id]="'name' + indice"
                formControlName="name"
                type="text"
                placeholder=""
                [maxlength]="HTML_VALIDATORS.maxLength.default"
              />
              <div class="error-content">
                @if (titular.controls['name'].touched && titular.controls['name'].hasError('required')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }

                @if (titular.controls['name'].touched && titular.controls['name'].hasError('minlength')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_minLength' | translate: { minLength: 3 } }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'firstSurname' + indice"
                [class.has-error]="
                  titular?.controls['firstSurname']?.touched && !titular?.controls['firstSurname'].valid
                "
              >
                {{ 'app_advance_simulator_form_surname' | translate }}
              </label>
              <input
                appOnlyLetters
                class="form-control"
                [id]="'firstSurname' + indice"
                formControlName="firstSurname"
                type="text"
                placeholder=""
                [maxlength]="HTML_VALIDATORS.maxLength.default"
              />
              <div class="error-content">
                @if (
                  titular.controls['firstSurname'].touched && titular.controls['firstSurname'].hasError('required')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'secondSurname' + indice"
                [class.has-error]="
                  titular?.controls['secondSurname']?.touched && !titular?.controls['secondSurname'].valid
                "
              >
                {{ 'app_advance_simulator_form_second_surname' | translate }}
              </label>
              <input
                appOnlyLetters
                class="form-control"
                [id]="'secondSurname' + indice"
                formControlName="secondSurname"
                type="text"
                placeholder=""
                [maxlength]="HTML_VALIDATORS.maxLength.default"
              />
              <div class="error-content">
                @if (
                  titular.controls['secondSurname'].touched && titular.controls['secondSurname'].hasError('required')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'idType' + indice"
                [class.has-error]="titular?.controls['idType']?.touched && !titular?.controls['idType'].valid"
              >
                {{ 'app_advance_simulator_form_idTime' | translate }}
              </label>
              <select
                [id]="'idType' + indice"
                formControlName="idType"
                (change)="updateValidatorIdType(titular, indice)"
              >
                <option disabled value="">{{ 'app_advance_simulator_form_idTime' | translate }}</option>
                <option *ngFor="let item of listDocumentType | async" [value]="item.code">
                  {{ item.description }}
                </option>
              </select>
              <div class="error-content">
                @if (titular.controls['idType'].touched && titular.controls['idType'].hasError('required')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'idNumber' + indice"
                [class.has-error]="titular?.controls['idNumber']?.touched && !titular?.controls['idNumber'].valid"
              >
                {{ 'app_advance_simulator_form_idNumber' | translate }}
              </label>
              @if (indice != 0) {
                <input
                  class="form-control"
                  [id]="'idNumber' + indice"
                  formControlName="idNumber"
                  type="text"
                  placeholder=""
                  [maxlength]="HTML_VALIDATORS.maxLength.default"
                />
              }

              @if (indice == 0) {
                <input
                  class="form-control"
                  [id]="'idNumber' + indice"
                  [value]="titular.controls['idNumber'].value"
                  disabled
                  type="text"
                  placeholder=""
                />
              }
              <div class="error-content">
                @if (titular.controls['idNumber'].touched && titular.controls['idNumber'].hasError('required')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }

                @if (
                  titular.controls['idNumber'].touched && titular.controls['idNumber'].hasError('validateDocument')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_invalid_format' | translate }}
                  </p>
                }

                @if (titular.controls['idNumber'].touched && titular.controls['idNumber'].hasError('equalDocument')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_dni_difetent_firt_horder' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'birthDate' + indice"
                [class.has-error]="titular?.controls['birthDate']?.touched && !titular?.controls['birthDate'].valid"
              >
                {{ 'app_advance_simulator_form_birth_date' | translate }}
              </label>
              @if (defaultBirthDate) {
                <p-datepicker
                  [readonlyInput]="false"
                  [inputId]="'birthDate' + indice"
                  formControlName="birthDate"
                  [defaultDate]="defaultBirthDate"
                  dateFormat="dd/mm/yy"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  readonlyInput="true"
                  [yearRange]="configCalendar?.dtBirhDate?.yearRange"
                  [maxDate]="configCalendar?.dtBirhDate?.maxDate"
                  [minDate]="configCalendar?.dtBirhDate?.minDate"
                ></p-datepicker>
              }
              <div class="error-content">
                @if (titular.controls['birthDate'].touched && titular.controls['birthDate'].hasError('required')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>

          <div class="col">
            <div class="input-box">
              <label
                [for]="'gender' + indice"
                [class.has-error]="titular?.get('gender')?.touched && !titular?.get('gender').valid"
              >
                {{ 'app_advance_simulator_form_gender' | translate }}
              </label>
              <select [id]="'gender' + indice" formControlName="gender">
                <option disabled value="">
                  {{ 'app_advance_simulator_form_gender_selected_option' | translate }}
                </option>
                <option value="M">{{ 'app_advance_simulator_form_gender_option_man' | translate }}</option>
                <option value="W">{{ 'app_advance_simulator_form_gender_option_woman' | translate }}</option>
              </select>
              <div class="error-content">
                @if (titular.get('gender').touched && titular.get('gender').hasError('required')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'country' + indice"
                [class.has-error]="titular?.get('country')?.touched && !titular?.get('country').valid"
              >
                {{ 'app_advance_simulator_form_country' | translate }}
              </label>
              <select [id]="'country' + indice" formControlName="country">
                <option disabled value="">
                  {{ 'app_advance_simulator_form_country_selected_option' | translate }}
                </option>
                <option *ngFor="let item of countries$ | async" [value]="item.isoCode3">
                  {{ item.name }}
                </option>
              </select>
              <div class="error-content">
                @if (titular.get('country').touched && titular.get('country').hasError('required')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'nationality' + indice"
                [class.has-error]="titular?.get('nationality')?.touched && titular?.get('nationality').invalid"
              >
                {{ 'app_advance_simulator_form_nationality' | translate }}
              </label>
              <select [id]="'nationality' + indice" formControlName="nationality">
                <option disabled value="">
                  {{ 'app_advance_simulator_form_nationality_selected_option' | translate }}
                </option>
                <option
                  *ngFor="let item of countries$ | async"
                  [value]="item.isoCode3"
                  [disabled]="titular.get('idType').value === 'DOC_TYP_NIE' && item.isoCode3 === 'ESP'"
                  [hidden]="titular.get('idType').value === 'DOC_TYP_NIE' && item.isoCode3 === 'ESP'"
                >
                  {{ item.name }}
                </option>
              </select>
              <div class="error-content">
                @if (titular.get('nationality').touched && titular.get('nationality').hasError('required')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>

          <div class="col">
            <div class="input-box">
              <label
                [for]="'phone' + indice"
                [class.has-error]="titular?.controls['phone']?.touched && !titular?.controls['phone'].valid"
              >
                {{ 'app_advance_simulator_form_phone' | translate }}
              </label>
              <input
                class="form-control"
                [id]="'phone' + indice"
                formControlName="phone"
                type="tel"
                placeholder=""
                [maxlength]="HTML_VALIDATORS.maxLength.phone"
              />
              <div class="error-content">
                @if (titular.controls['phone'].touched && titular.controls['phone'].hasError('required')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }

                @if (titular.controls['phone'].touched && titular.controls['phone'].hasError('pattern')) {
                  <p class="has-error">
                    {{ 'hipotecas_error_invalid_format_phone' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'email' + indice"
                [class.has-error]="titular?.controls['email']?.touched && !titular?.controls['email'].valid"
              >
                {{ 'app_advance_simulator_form_email' | translate }}
              </label>
              @if (indice != 0) {
                <input
                  class="form-control"
                  [id]="'email' + indice"
                  formControlName="email"
                  type="email"
                  placeholder=""
                  [maxlength]="HTML_VALIDATORS.maxLength.email"
                />
              }

              @if (indice == 0) {
                <input
                  class="form-control"
                  [id]="'email' + indice"
                  [value]="titular.controls['email'].value"
                  disabled
                  type="email"
                  placeholder=""
                />
              }
              <div class="error-content">
                @if (titular.controls['email'].touched) {
                  @if (titular.controls['email'].hasError('required')) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  } @else if (titular.controls['email'].hasError('pattern')) {
                    <p class="has-error">
                      {{ 'hipotecas_error_email_format' | translate }}
                    </p>
                  } @else if (titular.controls['email'].hasError('equalEmail')) {
                    <p class="has-error">
                      {{ 'hipotecas_error_email_difetent_firt_horder' | translate }}
                    </p>
                  }
                }
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-box">
              <label
                [for]="'maritalStatus' + indice"
                [class.has-error]="
                  titular?.controls['maritalStatus']?.touched && !titular?.controls['maritalStatus'].valid
                "
              >
                {{ 'app_advance_simulator_form_marital_status' | translate }}
              </label>
              <select [id]="'maritalStatus' + indice" formControlName="maritalStatus" (change)="updateMaritalStatus()">
                <option disabled value="">
                  {{ 'app_advance_simulator_form_marital_status_selected_option' | translate }}
                </option>
                <option *ngFor="let item of listMaritalStatus$ | async" [value]="item.code">
                  {{ item.description }}
                </option>
              </select>
              <div class="error-content">
                @if (
                  titular.controls['maritalStatus'].touched && titular.controls['maritalStatus'].hasError('required')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>

          @if (titular?.controls?.maritalStatus?.value === 'CIV_STA_DEFA') {
            <div class="col">
              <div class="input-box">
                <label
                  [for]="'economicRegimeBeforeDivorce' + indice"
                  [class.has-error]="
                    titular?.controls['economicRegimeBeforeDivorce']?.touched &&
                    !titular?.controls['economicRegimeBeforeDivorce'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_economic_regime_before_divorce' | translate }}
                </label>
                <select [id]="'economicRegimeBeforeDivorce' + indice" formControlName="economicRegimeBeforeDivorce">
                  <option disabled value="">
                    {{ 'app_advance_simulator_form_economic_regime_before_divorce_selected_option' | translate }}
                  </option>
                  <option *ngFor="let item of listEconomicSystem$ | async" [value]="item.code">
                    {{ item.description }}
                  </option>
                </select>
                <div class="error-content">
                  @if (
                    titular.controls['economicRegimeBeforeDivorce'].touched &&
                    titular.controls['economicRegimeBeforeDivorce'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>
          }
        </div>

        <app-address-data-form
          [holder]="indice"
          [addressForm]="titular.controls.holderAddress"
          [HTML_VALIDATORS]="HTML_VALIDATORS"
          (onSaveAddressData)="saveAddressHolder(titular.controls.holderAddress, indice)"
        >
        </app-address-data-form>
        <h3 class="h-sub-section">{{ 'app_advance_simulator_form_economic_data' | translate }}</h3>
        <form [formGroup]="titular?.controls?.holderEmploymentData">
          <div class="row">
            <div class="col">
              <div class="input-box">
                <label
                  [for]="'monthlyIncome' + indice"
                  [class.has-error]="
                    titular?.controls?.holderEmploymentData?.controls['monthlyIncome']?.touched &&
                    !titular?.controls?.holderEmploymentData?.controls['monthlyIncome'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_monthly_income' | translate }}
                </label>
                <amount-input
                  [config]="{
                    id: 'monthlyIncome' + indice,
                    inputFormat: '*-2',
                    maxlength: 6,
                    xDeleteButton: false,
                    styleClass: 'input-number',
                    symbol: '€',
                  }"
                  formControlName="monthlyIncome"
                  placeholder="Ingresos mensuales"
                ></amount-input>
                <div class="error-content">
                  @if (
                    titular.controls?.holderEmploymentData?.controls['monthlyIncome'].touched &&
                    titular.controls?.holderEmploymentData?.controls['monthlyIncome'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }

                  @if (titular.hasError('maxIncome')) {
                    <p class="has-error">
                      {{ 'app_advance_simulator_error_max_income' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>
            <div class="col">
              <div class="input-box">
                <label
                  [for]="'monthlyIncome' + indice"
                  [class.has-error]="
                    titular?.controls?.holderEmploymentData?.controls['otherIncome']?.touched &&
                    !titular?.controls?.holderEmploymentData?.controls['otherIncome'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_other_monthly_income' | translate }}
                </label>
                <amount-input
                  [config]="{
                    id: 'otherIncome' + indice,
                    inputFormat: '*-2',
                    maxlength: 6,
                    xDeleteButton: false,
                    styleClass: 'input-number',
                    symbol: '€',
                  }"
                  formControlName="otherIncome"
                ></amount-input>
                <div class="error-content">
                  @if (
                    titular.controls?.holderEmploymentData?.controls['otherIncome'].touched &&
                    titular.controls?.holderEmploymentData?.controls['otherIncome'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>
            <div class="col">
              <div class="input-box">
                <label
                  [for]="'companyName' + indice"
                  [class.has-error]="
                    titular?.controls?.holderEmploymentData?.controls['companyName']?.touched &&
                    !titular?.controls?.holderEmploymentData?.controls['companyName'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_company_name' | translate }}
                </label>
                <input
                  [id]="'companyName' + indice"
                  class="form-control"
                  formControlName="companyName"
                  type="text"
                  placeholder=""
                  [maxlength]="HTML_VALIDATORS.maxLength.companyName"
                />
                <div class="error-content">
                  @if (
                    titular.controls?.holderEmploymentData?.controls['companyName'].touched &&
                    titular.controls?.holderEmploymentData?.controls['companyName'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>
            <div class="col">
              <div class="input-box">
                <label
                  [for]="'employmentSituation' + indice"
                  [class.has-error]="
                    titular?.controls?.holderEmploymentData?.controls['employmentSituation']?.touched &&
                    !titular?.controls?.holderEmploymentData?.controls['employmentSituation'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_employment_situation' | translate }}
                </label>
                <select
                  [id]="'employmentSituation' + indice"
                  formControlName="employmentSituation"
                  (change)="updateCompanyName(titular?.controls?.holderEmploymentData)"
                >
                  <option disabled value="">
                    {{ 'app_advance_simulator_form_employment_situation_selected_option' | translate }}
                  </option>
                  <option *ngFor="let item of listEmploymentSituation$ | async" [value]="item.code">
                    {{ item.code | translate }}
                  </option>
                </select>
                <div class="error-content">
                  @if (
                    titular.controls?.holderEmploymentData?.controls['employmentSituation'].touched &&
                    titular.controls?.holderEmploymentData?.controls['employmentSituation'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>

            <div class="col">
              <div class="input-box">
                <label
                  [for]="'laborSeniority' + indice"
                  [class.has-error]="
                    titular?.controls?.holderEmploymentData?.controls['laborSeniority']?.touched &&
                    !titular?.controls?.holderEmploymentData?.controls['laborSeniority'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_labor_seniority' | translate }}
                </label>
                <select [id]="'laborSeniority' + indice" formControlName="laborSeniority">
                  <option disabled value="">
                    {{ 'app_advance_simulator_form_labor_seniority_selected_option' | translate }}
                  </option>
                  <option *ngFor="let item of listSeniorityCompany$ | async" [value]="item.code">
                    {{ item.code | translate }}
                  </option>
                </select>
                <div class="error-content">
                  @if (
                    titular.controls?.holderEmploymentData?.controls['laborSeniority'].touched &&
                    titular.controls?.holderEmploymentData?.controls['laborSeniority'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>

            <div class="col">
              <div class="input-box">
                <label
                  [for]="'activitySector' + indice"
                  [class.has-error]="
                    titular?.controls?.holderEmploymentData?.controls['activitySector']?.touched &&
                    !titular?.controls?.holderEmploymentData?.controls['activitySector'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_activity_sector' | translate }}
                </label>
                <select [id]="'activitySector' + indice" formControlName="activitySector">
                  <option disabled value="">
                    {{ 'app_advance_simulator_form_activity_sector_selected_option' | translate }}
                  </option>
                  <option *ngFor="let item of listActivitySector$ | async" [value]="item.code">
                    {{ item.code | translate }}
                  </option>
                </select>
                <div class="error-content">
                  @if (
                    titular.controls?.holderEmploymentData?.controls['activitySector'].touched &&
                    titular.controls?.holderEmploymentData?.controls['activitySector'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>

            <div class="col">
              <div class="input-box">
                <label
                  [for]="'academicLevel' + indice"
                  [class.has-error]="
                    titular?.controls?.holderEmploymentData?.controls['academicLevel']?.touched &&
                    !titular?.controls?.holderEmploymentData?.controls['academicLevel'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_academic_level' | translate }}
                </label>
                <select [id]="'academicLevel' + indice" formControlName="academicLevel">
                  <option disabled value="">
                    {{ 'app_advance_simulator_form_academic_level_selected_option' | translate }}
                  </option>
                  <option *ngFor="let item of listAcademicLevel$ | async" [value]="item.code">
                    {{ item.code | translate }}
                  </option>
                </select>
                <div class="error-content">
                  @if (
                    titular.controls?.holderEmploymentData?.controls['academicLevel'].touched &&
                    titular.controls?.holderEmploymentData?.controls['academicLevel'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>
            <div class="col">
              <div class="input-box">
                <label
                  [for]="'professionalLevel' + indice"
                  [class.has-error]="
                    titular?.controls?.holderEmploymentData?.controls['professionalLevel']?.touched &&
                    !titular?.controls?.holderEmploymentData?.controls['professionalLevel'].valid
                  "
                >
                  {{ 'app_advance_simulator_form_professional_level' | translate }}
                </label>
                <select [id]="'professionalLevel' + indice" formControlName="professionalLevel">
                  <option disabled value="">
                    {{ 'app_advance_simulator_form_academic_level_selected_option' | translate }}
                  </option>
                  <option *ngFor="let item of listProfessionalLevel$ | async" [value]="item.code">
                    {{ item.code | translate }}
                  </option>
                </select>
                <div class="error-content">
                  @if (
                    titular.controls?.holderEmploymentData?.controls['professionalLevel'].touched &&
                    titular.controls?.holderEmploymentData?.controls['professionalLevel'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>
          </div>
        </form>
      </form>
    </div>
  </div>
</div>
